import React, { Component } from "react";
import SignInScreen from "./SignInScreen";
import { forgotPassword } from "./dao/auth";
import { isValidEmail } from "./utils";

class ForgetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      sent: false,
    };

    this.onChange = this.onChange.bind(this);
    this.sendPassword = this.sendPassword.bind(this);
    this.resetState = this.resetState.bind(this);
  }

  resetState() {
    if (this.state.sent) {
      this.setState({
        email: "",
        sent: false,
      });
    }
  }

  onChange(event) {
    const { name, value } = event.target;
    this.setState({
      [name]: value,
    });
  }

  sendPassword() {
    console.log(this.state.email, isValidEmail(this.state.email));
    //forgotPassword();
    this.setState({
      sent: true,
    });
  }

  render() {
    if (!this.props.appProps2.state.forgotPassword) {
      return (
        <SignInScreen
          appProps={this.props.appProps2}
          resetChild={this.resetState}
        />
      );
    }
    if (this.state.sent) {
      return (
        <div className="container p-5" style={{ maxWidth: "500px" }}>
          <div class="container p-2 text-center">
            <h3>Forgot Password</h3>
            <hr className="w-75"></hr>
          </div>
          {this.state.sent ? (
            <div class="alert alert-success text-center">
              <strong>Email Sent! </strong>Please check your email and login
              with new reset password
            </div>
          ) : (
            <div>
              <br />
            </div>
          )}
        </div>
      );
    }
    return (
      <div>
        <div
          className="w-100 container p-0 my-5 border rounded glassmorph"
          style={{ maxWidth: "400px" }}
        >
          <div class="container p-2 text-center gradientTop">
            <h3>Forgot Password</h3>
            <hr className="w-75"></hr>
          </div>

          <p className="text-center text-secondary p-2">
            <small>
              Please enter your email adress of your account and we will send
              and email regarding reseting your password
            </small>
          </p>
          <div className="container p-3">
            <div className="form-group">
              <input
                type="email"
                placeholder="Email"
                className="form-control shadow-none"
                name="email"
                value={this.state.email}
                onChange={this.onChange}
                required
              />
            </div>

            <button
              type="button"
              className="btn btn-secondary btn-block"
              disabled={!isValidEmail(this.state.email)}
              value="login"
              onClick={this.sendPassword}
            >
              Send
            </button>
          </div>
        </div>
        <div className="container" style={{ maxWidth: "400px" }}>
          {this.state.sent ? (
            <div class="alert alert-success text-center">
              <strong>Email Sent! </strong>Please check your email and login
              with new reset password
            </div>
          ) : (
            <div>
              <br />
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ForgetPassword;
